import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { ContentBox, EmptyBox } from "../../libs/theme";
import REST from '../../libs/API';
import { formatDate, getText } from '../../libs/utils';
import { useTheme, styled } from '@mui/material/styles';
import {ArrowDown} from '../../assets/images/icons';

const MyGrid = styled(Grid)(({ theme }) => ({
  paddingBottom: '8px',
  marginBottom: '8px',
  "&:last-child": {
    paddingBottom: 0,
    marginBottom: 0
  },
  [theme.breakpoints.only('xs')]: {
    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    paddingBottom: '25px',
    marginBottom: '25px',
    "&:last-child": {
      border: 0,
      paddingBottom: 0,
      marginBottom: 0
    }
  }
}))

const ArrowPager = styled(Box)(() => ({
  cursor: 'pointer',
  display: 'inline-block',
  margin: '0 7px',
  "&.prev": {
    transform: 'rotate(90deg)',
  },
  "&.next": {
    transform: 'rotate(-90deg)',
  },
  "&.disabled": {
    opacity: 0.4,
    pointerEvents: 'none'
  },
}))

const GridContent = styled(Typography)(({theme}) => ({
  [theme.breakpoints.only('xs')]: {
    fontWeight: '600',
    lineHeight: '26px'
  }
}))

const RefsIncome = ({ userToken }) => {
  const theme = useTheme();
  let isXS = useMediaQuery(theme.breakpoints.only('xs'));
  const [incomeData, setIncomeData] = useState({data: [], pagination: {}});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getRefList();
  }, []);

  const getRefList = (page = 1) => {
    setLoading(true);
    REST.getRefIncomeList(userToken, {page, perPage: 10}).then(( {data, pagination} ) => {
      setIncomeData({data, pagination});
      setLoading(false);
    });
  }
  
  const {pagination, data} = incomeData;
  return (
    <ContentBox sx={{ padding: '24px 32px 25px', minHeight: { lg: '440px', xs: '200px' } }}>
      {loading
        ? <span className="dot-spin centered"></span>
        : !data.length
          ? <EmptyBox sx={{ width: { sm: '380px' } }}>
            <Typography>{getText('refIncomesNotFoundText')}</Typography>
          </EmptyBox>
          : <>
            {!isXS && <Grid container sx={{ margin: '0 0 24px' }}>
              <Grid item md={2} sm={3}>
                <Typography variant="boldCaption">{getText('orcardDateCol')}</Typography>
              </Grid>
              <Grid item md={3} sm={3}>
                <Typography variant="boldCaption">Email</Typography>
              </Grid>
              <Grid item md={3} sm={3}>
                <Typography variant="boldCaption">{getText('accRefStSumorder')}</Typography>
              </Grid>
              <Grid item md={3} sm={2}>
                <Typography variant="boldCaption">{getText('orcardStateCol')}</Typography>
              </Grid>
              <Grid item md={1} sm={1} sx={{textAlign: 'right'}}>
                {(pagination.pageCount > 1 && !isXS) && <>
                  {pagination.currentPage > 1 &&
                    <ArrowPager
                      className={`prev ${pagination.currentPage === 1 && ' disabled '}`}
                      onClick={() => getRefList(pagination.currentPage - 1)}
                    >
                      <ArrowDown />
                    </ArrowPager>
                  }
                  {pagination.pageCount > pagination.currentPage &&
                    <ArrowPager
                      className={`next ${pagination.pageCount === pagination.currentPage && ' disabled '}`}
                      onClick={() => getRefList(pagination.currentPage + 1)}
                    >
                      <ArrowDown />
                    </ArrowPager>
                  }
                </>}
              </Grid>
            </Grid>}

            {data.map((row, key) => (
              <MyGrid key={key} container>
                <Grid item md={2} sm={3} xs={6}>
                  <GridContent>{formatDate(new Date(row.createdAt))}</GridContent>
                  {isXS && <Typography sx={{ fontSize: 12, color: "primary.grey", marginBottom: '13px' }}>{getText('orcardDateCol')}</Typography>}
                </Grid>
                <Grid item md={3} sm={3} xs={6}>
                  <GridContent>{row.email}</GridContent>
                  {isXS && <Typography sx={{ fontSize: 12, color: "primary.grey", marginBottom: '13px' }}>Email</Typography>}
                </Grid>
                <Grid item md={3} sm={3} xs={6}>
                  <GridContent>{row.payment.amount} {row.payment.currencyCode}</GridContent>
                  {isXS && <Typography sx={{ fontSize: 12, color: "primary.grey" }}>{getText('accRefStSumorder')}</Typography>}
                </Grid>
                <Grid item md={4} sm={3} xs={6}>
                  <GridContent>{row.status}</GridContent>
                  {isXS && <Typography sx={{ fontSize: 12, color: "primary.grey" }}>{getText('orcardStateCol')}</Typography>}
                </Grid>
              </MyGrid>
            ))}

            {(pagination.pageCount > 1 && isXS) && <Box sx={{ textAlign: 'center' }}>
              {pagination.currentPage > 1 &&
                <ArrowPager
                  className={`prev ${pagination.currentPage === 1 && ' disabled '}`}
                  onClick={() => getRefList(pagination.currentPage - 1)}
                >
                  <ArrowDown />
                </ArrowPager>
              }
              {pagination.pageCount > pagination.currentPage &&
                <ArrowPager
                  className={`next ${pagination.pageCount === pagination.currentPage && ' disabled '}`}
                  onClick={() => getRefList(pagination.currentPage + 1)}
                >
                  <ArrowDown />
                </ArrowPager>
              }
            </Box>}

          </>
      }
    </ContentBox>
  )
}

export default RefsIncome